import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-pw',
  templateUrl: './reset-pw.component.html',
  styleUrls: ['./reset-pw.component.scss']
})
export class ResetPwComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
